<template>
  <main id="main-container">
    <div class="row no-gutters bg-primary-op">
      <div class="hero-static col-md-6 d-flex align-items-center bg-white">
        <div class="p-3 w-100">
          <div class="mb-3 text-center">
            <a class="link-fx font-w700 font-size-h1" href="/">
              <span class="text-dark">ARX</span>
              <span class="text-primary">editor</span>
            </a>
            <p class="text-uppercase font-w700 font-size-sm text-muted">
              Sign In
            </p>
          </div>
          <div class="row no-gutters justify-content-center">
            <div class="col-sm-8 col-xl-6">
              <div class="alert alert-danger" role="alert" v-if="error">
                <p class="mb-0" v-html="error"></p>
              </div>
              <form @submit.prevent="loginPost" class="js-validation-signin">
                <div class="py-3">
                  <div class="form-group">
                    <input
                      type="email"
                      class="form-control form-control-lg form-control-alt"
                      id="login-username"
                      name="email"
                      placeholder="Email"
                      v-model="data.email"
                      required
                    />
                  </div>
                  <div class="form-group">
                    <input
                      type="password"
                      class="form-control form-control-lg form-control-alt"
                      id="login-password"
                      name="password"
                      placeholder="Password"
                      v-model="data.password"
                      required
                    />
                  </div>
                </div>
                <div class="form-group">
                  <button
                    type="submit"
                    class="btn btn-block btn-hero-lg btn-hero-primary"
                  >
                    <i class="fa fa-fw fa-sign-in-alt mr-1"></i> Sign In
                  </button>
                </div>
                <div class="form-group">
                  <p class="mt-3 mb-0 d-lg-flex justify-content-lg-between">
                    <a
                      class="btn btn-sm btn-light d-block d-lg-inline-block mb-1"
                      href="http://api.arx.amatis.dev/password/reset"
                    >
                      <i class="fa fa-exclamation-triangle text-muted mr-1"></i>
                      Forgot password
                    </a>
                  </p>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div
        class="hero-static col-md-6 d-none d-md-flex align-items-md-center justify-content-md-center text-md-center"
      >
        <div class="p-3">
          <p class="display-4 font-w700 text-white mb-3">klik met je klant</p>
          <p class="font-size-lg font-w600 text-white-75 mb-0">
            Copyright &copy;
            <span data-toggle="year-copy"></span>
          </p>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "SignIn",
  data() {
    return {
      data: {
        email: null,
        password: null
      },
      error: null
    };
  },
  methods: {
    ...mapActions({
      login: "forms/login"
    }),
    loginPost(e) {
      e.preventDefault();
      this.login(this.data).then(response => {
        if (response.status) {
          window.location.href = "/";
          //this.$router.push("/");
        } else {
          this.error = response.message;
        }
      });
    }
  }
};
</script>

<style scoped></style>
